/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// ai-connectors.MINE.1: the AI connections the current person made, across
// accounts. See Api::V1::Profile::KaptionAiConnectionsController.
class KaptionAiConnectionsAPI extends ApiClient {
  constructor() {
    super('profile/kaption_ai_connections', { accountScoped: false });
  }

  disconnect(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new KaptionAiConnectionsAPI();
